import { Row, Space } from "@masterteam/mt-design-react";
import React from "react";
import { FormattedMessage } from "react-intl";

import DoughnutChart from "../../DoughnutChart";
import DetailsCard from "../DetailsCard";

import { useIsAr } from "../../../Hooks";

import { ReactComponent as DateIcon } from "../../../assets/images/calendar-icon.svg";
import { ReactComponent as DepartmentIcon } from "../../../assets/images/department-icon.svg";
import { ReactComponent as InfoIcon } from "../../../assets/images/info-icon.svg";
import { ReactComponent as ProjectsIcon } from "../../../assets/images/initiative-icon.svg";
import { ReactComponent as ResultsIcon } from "../../../assets/images/mission.svg";
import { ReactComponent as KPIsIcon } from "../../../assets/images/objectives-icon.svg";
import { ReactComponent as RiskIcon } from "../../../assets/images/risks-icon.svg";
import { ReactComponent as UserIcon } from "../../../assets/images/user.svg";

import { formatDate } from "../../../helpers";
import "./style.scss";

const InfoCards = ({ objective, kpisStatus, projectStatuses, isSupportive }) => {
  const [isAr] = useIsAr();
  return (
    <Space className="info-cards" direction="vertical" size="large">
      <Row size="large" align="stretch">
        <Row size="large" align="stretch">
          <DetailsCard icon={<KPIsIcon />} title="common.strategic-kpis">
            <Row justify="center" className="doughnut-chart-wrapper">
              <DoughnutChart
                data={objective?.KPIChart?.ChartData || []}
                statuses={kpisStatus}
                count={objective?.KPIChart?.Count}
                detailsTitle={"common.strategic-kpis"}
                detailsData={objective?.KPIs}
              />
            </Row>
          </DetailsCard>

          <DetailsCard
            icon={<ProjectsIcon />}
            title={isSupportive ? "common.initiatives" : "common.projects"}
          >
            <Row justify="center" className="doughnut-chart-wrapper">
              <DoughnutChart
                data={objective?.LevelChart?.ChartData || []}
                statuses={projectStatuses}
                count={objective?.LevelChart?.Count}
                detailsTitle={!isSupportive ? "common.strategic-projects" : "strategy-map.initiatives-list"}
                detailsData={objective?.LevelChart?.List}
                showNoData
                isProject={!isSupportive}
                isInitiative={isSupportive}
                staticPlannedColor={"#007DC5"}
              />
            </Row>
          </DetailsCard>
        </Row>

        <DetailsCard
          icon={<InfoIcon />}
          title="objective.objective-description"
        >
          <Space direction="vertical" className="description-wrapper">
            <div className="text">
              {isAr
                ? objective?.ArabicDescription
                : objective?.EnglishDescription}
            </div>
            <Space gap={48}>
              <Space align="center" gap={8}>
                <Space align="center">
                  <UserIcon />
                  <FormattedMessage id="objective.objective-owner" />:
                </Space>
                <div>{objective?.OwnerModel.DisplayName}</div>
              </Space>

              {+objective?.StrategyType === 2 ? (
                <Space align="center" gap={8}>
                  <Space align="center">
                    <DepartmentIcon />
                    <FormattedMessage id="common.department" />:
                  </Space>
                  <div>
                    {objective?.ObjectiveDepartments?.map((e) =>
                      isAr ? e?.ArabicName : e?.EnglishName
                    )?.join(",")}
                  </div>
                </Space>
              ) : null}
            </Space>

            {+objective?.StrategyType === 2 ? (
              <Space align="center" gap={8}>
                <Space align="center">
                  <DateIcon />
                  <FormattedMessage id="common.start-date" />:
                </Space>
                <div>
                  {objective?.StartDate
                    ? formatDate(objective?.StartDate)
                    : "---"}
                </div>
              </Space>
            ) : null}
          </Space>
        </DetailsCard>
      </Row>

      <Row size="large" align="stretch">
        <DetailsCard icon={<ResultsIcon />} title="objective.desired-results">
          <ul className="list-wrapper">
            {objective.ObjectiveResults?.map((e) => (
              <li key={e.ID}>{isAr ? e.ArabicName : e.EnglishName}</li>
            ))}
          </ul>
        </DetailsCard>

        <DetailsCard icon={<RiskIcon />} title="objective.risks">
          <ul className="list-wrapper">
            {objective.ObjectiveRisks?.map((e) => (
              <li key={e.ID}>{isAr ? e.ArabicName : e.EnglishName}</li>
            ))}
          </ul>
        </DetailsCard>
      </Row>
    </Space>
  );
};

export default InfoCards;
